export default __webpack_public_path__ + "static/media/Threejs_101.d33921a0.jpeg";